/*jslint unparam: true */
"use strict";

var $ = require("pli/jquery");
var AlternateRowSelectionModel = require("./slick.alternaterowselectionmodel");


//-------------------------------------------
function AlternateGrouping(sourceOptions) {
    /// <summary>Pli grouped index plugin for slick grid</summary>
    /// <remarks>
    /// Does not support editable grids because there is no way to recompute groups/indicies.
    /// updates slick.grid data to support two additional methods on data (getIndex - and getGroups)
    /// getIndex    - returns an array specifying the sorted position in the raw data.
    /// getGroups   - returns an array of groups is an array of group defintion. The group definition properties are as follows:
    ///                 name        - the name displayed for the group. (required)
    ///                 length      - the number of items in the group. (required)
    ///                 isCollapsed - true if the group is collapsed otherwise false. default(false)
    ///                 min         - the lower boundary of the group (computed)
    ///                 max         - the upper boundary of the group (computed)
    ///                 offset      - the start position in the array of data (computed)
    /// </remarks>
    var self = {},
        /// <summary>The current instance of the plugin.</summary>

        currentIndex,
        /// <summary>The current index in use.</summary>

        currentGroupSet,
        /// <summary>The current set of groups set in use.</summary>

        defaultOptions = {

            defaultSort: null,
            /// <summary>The object used to identify the column to initialize sort by. { field: "fieldName", isDescending: false }</summary>

            groupHeaderRenderer: null,
            /// <summary>A delegate of the form function(row, cell, value, columnDef, dataContext, options) {} for custom group header rendering.</summary>

            disableCollapse: false,
            /// <summary>A boolean indicating whether groups are collapsible.</summary>

            hasNoGroupSpacer: false
            /// <summary>A boolean indicating there is a spacer row above groups.</summary>

        },
        /// <summary>The default set of options for the control.</summary>

        hiddenSelected = [],
        /// <summary>an array containing the data index of items that are hidden in the grid but still selected.
        /// Used to maintain selected items when collapsing expanding a group and filtering.</summary>

        isDescending = false,
        /// <summary>Indicates the current sort direction.</summary>

        grid,
        /// <summary>The current instance of slick.grid</summary>

        gridOptions,
        /// <summary>The current instance of slick.grid options</summary>

        gridData,
        /// <summary>The current instance of slick.grid data</summary>

        gridColumns,
        /// <summary>The current instance of slick.grid columns</summary>

        groupsSets = {},
        /// <summary>The collection of the array of sets of groups per column.</summary>

        filter,
        /// <summary>Provides the filtered data.</summary>

        length,
        /// <summary>The cached length of the data.</summary>

        lastIndex,
        /// <summary>The last index that was retrieved from getItem</summary>

        lastGroupIndex,
        /// <summary>The index of the last group that was retrieved from getItem</summary>

        lastRow,
        /// <summary>The last row of data that was retrieved from getItem</summary>

        lastSortColumn,
        /// <summary></summary>

        selectionModel,
        /// <summary></summary>

        options = $.extend(true, {}, defaultOptions, sourceOptions);
        /// <summary>The current instance of the options for the plugin</summary>


    //~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~
    // Private Methods

    //-------------------------------------------
    function getSelectedDataIndex() {
        /// <summary>Gets the selected items by data index.</summary>
        var current = grid.getSelectedRows(),
            i,
            selectedDataIndex = [];
        for (i = 0; i < current.length; i = i + 1) {
            selectedDataIndex.push(grid.getDataItem(current[i]).dataIndex);
        }
        return {
            rows: selectedDataIndex,
            lastRow: (current.length > 0 ? current[current.length - 1] : null)
        };
    }


    //-------------------------------------------
    function getGroupRows(group) {
        /// <summary>Returns the selected rows for the group specified.</summary>
        var result = [], i;
        if (group) {
            for (i = group.min + (options.hasNoGroupSpacer ? 1 : 2); i <= group.max; i = i + 1) {
                result.push(isDescending ? length - (i - (options.hasNoGroupSpacer ? 0 : 1)) : i);
            }
        }
        return result;
    }


    //-------------------------------------------
    function initHeaderRenderer(customFormatter) {
        /// <summary>Initializes the renderer for groups</summary>
        return function renderHeader(row, cell, value, columnDef, dataContext) {
            /// <summary>Renders the group header/spacer.</summary>
            var header, result;

            if (!dataContext || dataContext.isHeader !== true || dataContext.isSpacer) {
                //if the row is neither a header or a spacer then render the custom formatter
                //which was specified in the original column definition
                return typeof customFormatter === "function"
                        ? customFormatter(row, cell, value, columnDef, dataContext)
                        : value || "";
            }

            if (dataContext.isHeader === true) {
                // Check for custom group header rendering
                if (typeof defaultOptions.groupHeaderRenderer === "function") {
                    result = defaultOptions.groupHeaderRenderer(row, cell, value, columnDef, dataContext, options);
                } else {
                    // Default group Header Rendering
                    header = "";
                    if (options.disableCollapse !== true) {
                        header = header.concat("<span class=\"slick-group-toggle ")
                            .concat(dataContext.isCollapsed ? "collapsed" : "expanded")
                            .concat("\"></span>");
                    }
                    result = header.concat(dataContext.name || "");
                }
                return result;
            }
        };
    }


    //-------------------------------------------
    function computeGroup(group, start) {
        /// <summary>Computes the min, max and offset for each group.</summary>
        /// <param name="group">The array of group definition to compute</param>
        /// <param name="start">The index to compute the start of the group from.  This can be used when collapsing/expanding
        /// because only need to compute after and including the group being collapsed/expanded.</param>
        var lastMax,
            offset,
            min = 0,
            max = 0,
            adjustment = 0,
            current,
            i;

        start = start || 0;
        lastMax = (group[start].min || 0) - 1;
        offset = (group[start].offset || 0);

        for (i = start; i < group.length; i += 1) { // Compute the min/max and offset.
            current = group[i];
            min = lastMax + 1;
            adjustment = adjustment - ((current.isCollapsed && !options.disableCollapse) ? current.length : 0); // Adjust for collapsed.
            max = lastMax = min + current.length + (options.hasNoGroupSpacer ? 0 : 1) - ((current.isCollapsed && !options.disableCollapse) ? current.length : 0);
            current = $.extend(current, { min: min, max: max, offset: offset });
            offset = offset + current.length;
        }

        return adjustment;
    }


    //-------------------------------------------
    function binarySearchGroup(items, value) {
        /// <summary>Searchs the specified array until it meets the
        /// comparer function returns zero.</summary>
        /// <param name="items">An array of items to search</param>
        /// <param name="comparer">A function that returns -1 when the
        /// target is greater than the item, 0 when the target is equal or
        /// 1 when the target is less than the item</param>
        /// <returns>The index of the item or null if the item was not found</returns>
        var low = 0, high = items.length - 1, index, current;

        while (low <= high) {
            index = Math.floor((low + high) / 2);
            current = items[index];
            if (value > current.max) {
                low += 1;
            } else if (value < current.min) {
                high -= 1;
            } else {
                return index;
            }
        }
        return null; // no results
    }


    //-------------------------------------------
    function searchGroupByIndex(items, value) {
        /// <summary></summary>
        var pos = 0, foundIndex = null;
        $.each(items, function eachGroup(groupIndex, targetGroup) {
            pos = pos + targetGroup.length;
            if (value < pos) {
                foundIndex = { index: groupIndex, group: targetGroup };
                return false;
            }
        });
        return foundIndex;
    }


    //-------------------------------------------
    function getItem(rowIndex) {
        /// <summary>Returns the data for the specified row to slick grid at the specified index.</summary>
        /// <param name="rowIndex">The current index in slick.grid</param>

        var relativeRowIndex, dataIndex, group, header, spacer, previous, next, item;

        // Verify if the target item was the last item accessed.
        // (The last item is cached for performance because getItem
        // is called for each field in a row.)
        if (lastIndex === rowIndex && lastRow) {
            return lastRow;
        }
        lastIndex = rowIndex;

        // Calculate the inverse of the rowIndex if the sort order is descending.
        relativeRowIndex = (isDescending ? (length - 1 - rowIndex) : rowIndex);

        if (!currentGroupSet) { // no group specified.

            dataIndex = currentIndex
                ? currentIndex[relativeRowIndex]
                : relativeRowIndex;
            lastRow = gridData.getItem(dataIndex);
            item = $.extend(lastRow, { dataIndex: dataIndex });

        } else { // handle groups.

            // Verify if this item is in the last group that was used.
            // (The group is cached for performance so that we don't need to look it up
            // for each row.)
            group = currentGroupSet[lastGroupIndex];
            if (group && (relativeRowIndex < group.min || relativeRowIndex > group.max)) {
                group = null; // reset if this is not the correct group
            }

            if (group ===  null || group === undefined) { // if the group is not set find the current group based on the realtive row index.

                // first we check the previous and next groups for performance.  If it is neither
                // we use the binary search to locate the current group.
                previous = currentGroupSet[lastGroupIndex - 1];
                next = currentGroupSet[lastGroupIndex + 1];
                if (previous && relativeRowIndex >= previous.min && relativeRowIndex <= previous.max) {
                    lastGroupIndex -= 1;
                } else if (next && relativeRowIndex >= next.min && relativeRowIndex <= next.max) {
                    lastGroupIndex += 1;
                } else {
                    lastGroupIndex = binarySearchGroup(currentGroupSet, relativeRowIndex);
                }

            }

            // Check if the current row is a header or a spacer. In the case of a header
            // igorne actual data and return fake row.
            group = currentGroupSet[lastGroupIndex];
            spacer = (isDescending ? group.max : group.min) + ((options.hasNoGroupSpacer ? 1 : 0) * (isDescending ? 1 : -1));
            header = (isDescending ? spacer - 1 : spacer + 1);
            if (relativeRowIndex === spacer) {
                lastRow = { isSpacer: true };
                item = lastRow;
            } else if (relativeRowIndex === header) {
                lastRow = $.extend({ isHeader: true, index: lastGroupIndex, isCollapsed: (group.isCollapsed ? true : false) }, group);
                item = lastRow;
            } else {
                // Compute the index in the raw data.
                dataIndex = relativeRowIndex - group.min; // Calculate the position within the group.
                dataIndex = dataIndex + group.offset; // determine the position within the raw data

                if (isDescending !== true) {
                    dataIndex = dataIndex - 1; // Accomodate for the header.
                    if (options.hasNoGroupSpacer !== true) {
                        dataIndex = dataIndex - 1; // Accomodate for the spacer.
                    }
                }

                if (currentIndex === null || currentIndex === undefined) {
                    lastRow = gridData.getItem(dataIndex); // otherwise access raw data directly.
                    item = $.extend(lastRow, { dataIndex: dataIndex });
                } else {
                    dataIndex = currentIndex[dataIndex];
                    lastRow = gridData.getItem(dataIndex); // if there is an index use it to lookup position.
                    item = $.extend(lastRow, { dataIndex: dataIndex });
                }
            }

        }
        return item;

    }


    //-------------------------------------------
    function getLength() {
        /// <summary>Returns the length of the grid to slick grid.</summary>
        return length;
    }


    //-------------------------------------------
    function extendGetItemMetadata(current) {
        return function getItemMetadata(row) {
            /// <summary>Adds metadata (row classes) for groups and spacers</summary>
            var metaData = $.isFunction(current) ? current(row) : {},
                activeCell = grid.getActiveCell(),
                activeRow = activeCell ? activeCell.row : null,
                selected,
                dataRow;

            if (row === lastIndex) {
                dataRow = lastRow;
            } else {
                dataRow = getItem(row);
            }
            dataRow = dataRow || {};

            if (dataRow.isSpacer) {

                metaData = $.extend(metaData, {
                    cssClasses: "group-spacer",
                    columns: { 0: { colspan: "*" } },
                    selectable: false,
                    focusable: false
                });

            } else if (dataRow.isHeader) {

                metaData = $.extend(metaData, {
                    cssClasses: "group-header",
                    columns: { 0: { colspan: "*" } },
                    selectable: false,
                    focusable: true,
                    select: function select() {
                        return getGroupRows(dataRow);
                    }
                });

            } else {
                selected = grid.getSelectedRows();
                if ($.inArray(row, selected) >= 0 && grid.canCellBeSelected(current, (activeCell ? activeCell.cell : 0))) {
                    metaData = $.extend(metaData, { cssClasses: (metaData.cssClasses || "").concat(" selected") });
                }

            }

            if (current === activeRow) {
                metaData = $.extend(metaData, { cssClasses: (metaData.cssClasses || "").concat(" active") });
            }

            return metaData;
        };
    }


    //--------------------------------------------------
    function sort(preSelected, adjustPosition) {
        /// <summary>Re-sorts the data based on the last index.</summary>
        /// <param name="preSelected">An object containing the following to properties
        ///  - rows - an array of the selected data index
        ///  - lastRow - the index of the lastRow selected</param>
        /// <param name="adjustPosition">true if adjust the position to keep the last row in view otherwise false.</param>
        var field,
            postSelectedRows = [],
            i,
            position,
            dataIndex;

        if (lastSortColumn === null || lastSortColumn === undefined) {
            // Set it to the data.
            lastGroupIndex = lastIndex = currentIndex = currentGroupSet = null;
            if (filter) {
                currentIndex = filter.items;
                length = filter.length;
            } else {
                length = gridData.getLength();
            }

        } else {
            field = lastSortColumn.field;

            // Set it to the data at the lastSortColumn
            lastGroupIndex = lastIndex = null;
            if (filter) {
                currentIndex = filter.indices[field] || filter.items;
                currentGroupSet = filter.groupsSets[field];
                length = filter.length;
            } else {
                currentIndex = gridData.getIndex(field);
                currentGroupSet = groupsSets[field];
                length = gridData.getLength();
            }

            if (currentGroupSet) {
                length = currentGroupSet.resolvedLength;
            }
        }

        // restore selected items
        if (!preSelected) { return; }
        if (preSelected.rows.length > 0 || hiddenSelected.length > 0) {
            for (i = 0; i < getLength(); i = i + 1) {
                dataIndex = getItem(i).dataIndex;

                // Check if the data index is in the preselected items.
                position = $.inArray(dataIndex, preSelected.rows);
                if (position > -1) {
                    if (grid.canCellBeSelected(i, 0)) {
                        postSelectedRows.push(i);
                    }
                    preSelected.rows.splice(position, 1);
                }

                // Check if the data index is in the hidden items.
                position = $.inArray(dataIndex, hiddenSelected);
                if (position > -1) {
                    if (grid.canCellBeSelected(i, 0)) {
                        postSelectedRows.push(i);
                    }
                    hiddenSelected.splice(position, 1);
                }

                if (preSelected.rows.length === 0 && hiddenSelected.length === 0) {
                    break;
                }
            }
            grid.setSelectedRows(postSelectedRows);
        }

        for (i = 0; i < preSelected.rows.length; i = i + 1) {
            hiddenSelected.push(preSelected.rows[i]);
        }

        grid.invalidate();

        // restore selected position
        if (adjustPosition && postSelectedRows.length > 0) {
            grid.setActiveCell(postSelectedRows[postSelectedRows.length - 1], 0);
        }
    }


    //-------------------------------------------
    function onSort(scope, e) {
        /// <summary>Handles slick.grid onSort event</summary>
        var preSelected = getSelectedDataIndex(),
            adjustPosition = e.adjustPosition === undefined ? true : !!e.adjustPosition;
        lastSortColumn = e.sortCol;
        isDescending = e.sortAsc !== true;

        sort(preSelected, adjustPosition);
    }


    //-------------------------------------------
    function onSelectedRowsChanged(e, data) {
        /// <summary></summary>
        var rows = data.rows,
            container = $(grid.getCanvasNode()),
            i,
            row;
        $(".slick-row").removeClass("selected");
        for (i = 0; i < rows.length; i = i + 1) {
            row = rows[i];
            if (grid.canCellBeSelected(row, 0) === true) {
                $(".slick-row[row=".concat(row).concat("]"), container).addClass("selected"); // add active if visible.
            }
        }
        if (grid.getOptions().multiSelect !== true && rows.length > 0) {
            hiddenSelected = [];
        }
    }


    //-------------------------------------------
    function onActiveCellChanged(e, data) {
        /// <summary></summary>
        var activeRow = data.row,
            container = $(grid.getCanvasNode());
        $(".slick-row", container).removeClass("active"); // remove any active
        $(".slick-row[row=".concat(activeRow).concat("]"), container).addClass("active"); // add active if visible.
    }


    //-------------------------------------------
    function onSelectedReset() {
        /// <summary></summary>
        hiddenSelected = [];
    }


    //-------------------------------------------
    function toggleGroupCollapsed(e, data) {
        /// <summary>Toggles whether the group is collapsed or not.</summary>
        var clicked = $(e.target),
            group,
            rowItem,
            preSelected;
        if (clicked.is(".slick-group-toggle") === true) {
            preSelected = getSelectedDataIndex();
            rowItem = data.grid.getDataItem(data.row);
            group = currentGroupSet[rowItem.index];
            group.isCollapsed = group.isCollapsed === true ? false : true;
            currentGroupSet.resolvedLength = currentGroupSet.resolvedLength + (group.isCollapsed ? (-1 * group.length) : group.length);
            length = currentGroupSet.resolvedLength;
            computeGroup(currentGroupSet, rowItem.index);
            sort(preSelected);
            e.stopImmediatePropagation();
        }
    }


    //-------------------------------------------
    function applyFilter(filterRowDelegate) {
        var currentItem,
            i,
            preSelected = getSelectedDataIndex();

        filter = { items: [], indices: {}, groupsSets: {} };

        // Filter the results.

        for (i = 0; i < gridData.getLength(); i = i + 1) {
            currentItem = gridData.getItem(i);
            if (filterRowDelegate(currentItem) === true) { // Verify that the item is included in the filter.
                filter.items.push(i);
            }
        }
        filter.length = filter.items.length;

        if (filter.length > 0) {

            // Re-build Indices (and groups that have indices)

            $.each(gridColumns, function eachColumn(key, value) { // Iterate indices

                var selectedGroupSet = groupsSets[value.field],
                    selectedIndex = gridData.getIndex(value.field),
                    position,
                    selectedGroup,
                    previousGroup = {},
                    filterIndex = [],
                    filterGroupSet = [];

                if ((selectedIndex === null || selectedIndex === undefined) && (selectedGroupSet === null || selectedGroupSet === undefined)) {
                    return true; // no index or group for the column continue - eachColumn
                }

                if (selectedIndex === null || selectedIndex === undefined) { // group only

                     // Iterate each of the filtered values and add to the group
                    for (i = 0; i < filter.items.length; i = i + 1) {

                        // find the group by index (then either increment existing or add new)
                        selectedGroup = searchGroupByIndex(selectedGroupSet, i);
                        if (selectedGroup.index === previousGroup.index) {
                            filterGroupSet[filterGroupSet.length - 1].length += 1;
                        } else {
                            filterGroupSet.push({ name: selectedGroup.group.name, length: 1, isCollapsed: selectedGroup.group.isCollapsed });
                        }
                        previousGroup = selectedGroup;

                    }

                    // Add the group.
                    filterGroupSet.resolvedLength = filter.items.length + computeGroup(filterGroupSet) + (filterGroupSet.length * (options.hasNoGroupSpacer ? 1 : 2));
                    filter.groupsSets[value.field] = filterGroupSet;


                } else { // index (and possibly a group)

                    // Iterate each of the values in the index and add to the filtered index and group (if specified)
                    for (i = 0; i < selectedIndex.length; i = i + 1) {
                        position = selectedIndex[i];
                        if ($.inArray(position, filter.items) > -1) {

                            filterIndex.push(position); // add the position to the filter index.

                            if (selectedGroupSet !== null && selectedGroupSet !== undefined) {
                                // find the group by index (then either increment existing or add new)
                                selectedGroup = searchGroupByIndex(selectedGroupSet, i);
                                if (selectedGroup.index === previousGroup.index) {
                                    filterGroupSet[filterGroupSet.length - 1].length += 1;
                                } else {
                                    filterGroupSet.push({ name: selectedGroup.group.name, length: 1, isCollapsed: selectedGroup.group.isCollapsed });
                                }
                                previousGroup = selectedGroup;
                            }

                        }
                    }

                    // Add the group and indices.
                    filter.indices[value.field] = filterIndex;
                    if (filterGroupSet.length > 0) {
                        filterGroupSet.resolvedLength = filter.items.length + computeGroup(filterGroupSet) + (filterGroupSet.length * (options.hasNoGroupSpacer ? 1 : 2));
                        filter.groupsSets[value.field] = filterGroupSet;
                    } else {
                        return false; // continue
                    }

                }

            });
        }
        sort(preSelected);
    }


    //-------------------------------------------
    self = $.extend(self, {


        //-------------------------------------------
        init: function initialize(sourceGrid) {
            /// <summary>Initializes the group plugin</summary>

            var internalSetData;

            grid = sourceGrid;
            internalSetData = grid.setData;
            gridOptions = grid.getOptions();
            gridData = grid.getData();
            gridColumns = grid.getColumns();

            // validation

            // Does not support editable grid because there is no way to recompute indices/groups
            if (gridOptions.editable === true) {
                throw new Error("PliGroupedIndexedGridPlugin.js does not support editable grids because there is no way to recompute indices/groups.");
            }

            if ($.isFunction(gridData.getIndex) !== true) {
                throw new Error("slick.grid data must provide a getIndex function");
            }

            if ($.isFunction(gridData.getGroups) !== true) {
                throw new Error("slick.grid data must provide a getGroups function");
            }

            // if collapsing is available add click handler. (need to register before selection model so it overrides)
            if (options.disableCollapse === false) {
                grid.onClick.subscribe(toggleGroupCollapsed);
            }

            if (typeof gridOptions.groupHeaderRenderer === "function") {
                defaultOptions.groupHeaderRenderer = gridOptions.groupHeaderRenderer;
            }

            // Set the selection model
            if (typeof AlternateRowSelectionModel === "function") {
                selectionModel = new AlternateRowSelectionModel();
                grid.setSelectionModel(selectionModel);
                selectionModel.onSelectedReset.subscribe(onSelectedReset);
            }

            // Add header formatter to the current columns.
            if (gridColumns.length > 0) {
                gridColumns[0].formatter = initHeaderRenderer(gridColumns[0].formatter);
            }

            // Subscribe to the sort event.
            grid.onSort.subscribe(onSort);

            // add css styles for active and selected on change.
            grid.onSelectedRowsChanged.subscribe(onSelectedRowsChanged);
            grid.onActiveCellChanged.subscribe(onActiveCellChanged);

            // Set the data.
            grid.setData = function setData(data) {
                lastIndex = lastGroupIndex = lastRow = currentIndex = currentGroupSet = null; // reset cached values.
                gridData = data;

                // Compute cached length.
                length = gridData.getLength();

                // initialize groups.

                // Loop through and the group sets and initialize computed field and copy groups.
                $.each(gridColumns, function eachColumn(columnIndex, columnValue) {
                    var groups = gridData.getGroups(columnValue.field);
                    if (groups && groups.length > 0) {
                        // copy the group
                        groups = groupsSets[columnValue.field] = $.extend(true, [], groups);

                        // compute each of the groups.
                        groups.resolvedLength = length + computeGroup(groups) + (groups.length * (options.hasNoGroupSpacer ? 1 : 2));
                    }
                });
                internalSetData({ getItem: getItem, getLength: getLength, getItemMetadata: extendGetItemMetadata(gridData.getItemMetadata) });

                if (lastSortColumn) { // restore existing column
                    grid.setSortColumn(lastSortColumn.field, isDescending);
                    grid.onSort.notify({
                        sortCol: lastSortColumn,
                        sortAsc: options.defaultSort.isDescending !== true,
                        adjustPosition: false
                    });
                } else { // set default.
                    if ($.isPlainObject(options.defaultSort) === true && options.defaultSort.field) {
                        grid.setSortColumn(options.defaultSort.field, options.defaultSort.isDescending !== true);
                        grid.onSort.notify({
                            sortCol: grid.getColumns()[grid.getColumnIndex(options.defaultSort.field)],
                            sortAsc: options.defaultSort.isDescending !== true,
                            adjustPosition: false
                        });
                    }
                }

            };
            grid.setData(gridData, false);

        },


        //-------------------------------------------
        destroy: function destroy() {
            /// <summary>Removes the grid functionality</summary>
            grid.onSort.unsubscribe(onSort);
            grid.onSelectedRowsChanged.unsubscribe(onSelectedRowsChanged);
            grid.onActiveCellChanged.unsubscribe(onActiveCellChanged);
            grid.setData(gridData);

            if (options.disableCollapse === false) {
                grid.onClick.unsubscribe(toggleGroupCollapsed);
            }

            if (typeof AlternateRowSelectionModel === "function") {
                selectionModel.onSelectedReset.unsubscribe(onSelectedReset);
                selectionModel.destroy();
            }
        },


        //-------------------------------------------
        applyFilter: applyFilter,
        /// <summary>Applies a filter to the current data.</summary>
        /// <param name='filterRowDelegate'>A delegate that is passed the item.  If the return value is true (not truthy) the item will be included otherwise it will not.</param>


        //-------------------------------------------
        clearFilter: function clearFilter() {
            var preSelected = getSelectedDataIndex();
            filter = lastGroupIndex = lastIndex = null;
            sort(preSelected);
        },
        /// <summary>Clears the current filter if there is one.</summary>


        //-------------------------------------------
        getSelectedItems: function getSelectedItems() {
            var selectedItems = [],
                item,
                selectedData = hiddenSelected.concat(getSelectedDataIndex().rows),
                i;
            for (i = 0; i < selectedData.length; i = i + 1) {
                item = gridData.getItem(selectedData[i]);
                if (item) {
                    selectedItems.push(item);
                }
            }
            return selectedItems;
        }
        /// <summary>Gets all the data that is currently selected in the including those that are not visible</summary>

    });


    return self;

}


module.exports = AlternateGrouping;



//////////////////
// WEBPACK FOOTER
// ./app/slickgrid/slick.alternategrouping.js
// module id = 524
// module chunks = 49